import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor, HTTP_INTERCEPTORS, HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import {TokenStorageService} from '../services/token-storage.service';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { GenericsService } from '../services/generics.service';
import {environment} from '../../environments/environment';
import {START_MODE} from '../app.constants';
import {NotificationService} from '../services/notification.service';

const TOKEN_HEADER_KEY = 'Authorization';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private excludedUrls: string[] = [
    '/api/local/gescom/v1/system/last/license',
    '/api/local/gescom/v1/users/details/',
    '/api/local/gescom/v1/users/log-out',
    '/api/local/gescom/v1/system/decrypt/license',
    '/assets/i18n/fr.json',
    '/assets/i18n/en.json'
  ];

  constructor(
    private token: TokenStorageService,
    private router: Router,
    private genericsService: GenericsService,
    public notifService: NotificationService,
  ) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    const tenantId = `${this.token.getTenantID()}`;
    const site = `${this.token.getCurrentSite()}`;
    const codeSite = `${this.token.getCodeSite()}`;
    const codeIsoLangue = `${this.token.getLangue()}`;
    const token = this.token.getToken();
    // const idUserConnected = `${this.token.getIdUserConnected()}`;
    const idUserConnected = `${this.token.getUser()?.id}`;
    let authReq = req;


    if (environment.startMode !== START_MODE.DEV) {

      if (this.isExcluded(req.url)) {
        // let authReq1 = req;
        if (token != null) {
          authReq = req.clone({
            headers: req.headers
              .set(TOKEN_HEADER_KEY, 'Bearer ' + token).append('X-TenantID', tenantId)
              .set(TOKEN_HEADER_KEY, 'Bearer ' + token).append('siteId', site)
              .set(TOKEN_HEADER_KEY, 'Bearer ' + token).append('codeSite', codeSite)
              .set(TOKEN_HEADER_KEY, 'Bearer ' + token).append('codeIsoLang', codeIsoLangue)
              .set(TOKEN_HEADER_KEY, 'Bearer ' + token).append('id-user-connected', idUserConnected)
          });
        } else {
          authReq = req.clone({
            headers: req.headers
              .set('X-TenantID', tenantId)
          });
        }

        return next.handle(authReq).pipe(
          catchError((error: HttpErrorResponse) => {
            if (error.status === 401 && token) {
              this.notifService.danger('Vous avez ouvert une nouvelle session sur une autre application. vous serez déconnecté.');
              setTimeout(() => {
                this.token.clearLocalStorage();
              }, 3000);
            }

            return throwError(error);
          })
        );
      }
    }

    if (token != null) {
      authReq = req.clone({
        headers: req.headers
          .set(TOKEN_HEADER_KEY, 'Bearer ' + token).append('X-TenantID', tenantId)
          .set(TOKEN_HEADER_KEY, 'Bearer ' + token).append('siteId', site)
          .set(TOKEN_HEADER_KEY, 'Bearer ' + token).append('codeSite', codeSite)
          .set(TOKEN_HEADER_KEY, 'Bearer ' + token).append('id-user-connected', idUserConnected)
          .set(TOKEN_HEADER_KEY, 'Bearer ' + token).append('codeIsoLang', codeIsoLangue)
      });
    } else {
      authReq = req.clone({
        headers: req.headers
          .set('X-TenantID', tenantId)
      });
    }
    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && token) {
          this.notifService.danger('Vous avez ouvert une nouvelle session sur une autre application. vous serez déconnecté.');
          setTimeout(() => {
            this.token.clearLocalStorage();
          }, 3000);
        }

        return throwError(error);
      })
    );
  }

  private isExcluded(url: string): boolean {
    // console.log('url', url);
    const staticPath = url.replace(/^(?:\/\/|[^/]+)*\//, '/');
    return this.excludedUrls.some(excludedUrl => staticPath.startsWith(excludedUrl));
  }
}

export const authInterceptorProviders = [
  {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true}
];
